export default {
	"order.transferOrder": "转单",
	"order.NoRefund": "无退款",
	"order.Refunding": "退款中",
	"order.RefundSuccessfully": "退款成功",
	"order.PendingPayment": "待付款",
	"order.toBeDelivered": "待发货",
	"order.PartiallyShipped": "部分发货",
	"order.Shipped": "已发货",
	"order.TransactionComplete": "交易完成",
	"order.TradingClosed": "交易关闭",
	"order.PaidWithoutAddress": "已支付无地址",
	"order.NoDeliveryRequired": "无需配送",
	"order.ExpressDelivery": "快递配送",
	"order.OnlyRefund": "仅退款",
	"order.refundReturn": "退款退货",
	"order.pendingReview": "待审核",
	"order.passed": "已通过",
	"order.rejected": "已拒绝",
	"order.Revoked": "已撤销",
	"order.creationTime": "创建时间",
	"order.passingTime": "通过时间",
	"order.rejectionTime": "拒绝时间",
	"order.CancellationTime": "撤销时间",
	"order.call": "叫叫",
	"order.calledMath": "叫叫数学",
	"order.calledLiteracy": "叫叫识字",
	"order.DownloadTheCallingLiteracyAPP": "下载【叫叫识字】APP",
	"order.clickToDownload": "点击下载",
	"order.OrScanTheCodeToDownloadAfterRegisteringAndLoggingInYouCanRedeemAndViewTheLiterateContent": "或者扫码下载，注册登录后可兑换和查看识字内容"
}